export default __webpack_public_path__ + "static/media/MyEvent_Return.eb79ccc8.svg";